"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "popup-outer" };
const _hoisted_2 = { class: "popup-inner" };
const _hoisted_3 = { class: "popup-header" };
const _hoisted_4 = { class: "popup-body" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createElementVNode)("div", _hoisted_3, [
                (0, vue_1.renderSlot)(_ctx.$slots, "header"),
                (0, vue_1.createElementVNode)("button", {
                    class: "close-button",
                    onClick: _cache[0] || (_cache[0] =
                        (...args) => (_ctx.onclick && _ctx.onclick(...args)))
                }, "Close")
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_4, [
                (0, vue_1.renderSlot)(_ctx.$slots, "default")
            ])
        ])
    ]));
}
